/* ==========================================================================
   Hive Keys — vehicle finder
   Cascading Year > Make > Model, matching the reference site. Remembers the
   chosen vehicle so the rest of the site can show "fits your vehicle" state.

   Data source: assets/hk-vehicles.json
   That file is generated from the product catalogue. Until the fitment data
   has been extracted into metafields the finder submits to search, which
   already works because make / model / year live inside the product titles.
   Swapping to metafield filtering later only means changing buildUrl().
   ========================================================================== */
(function () {
  'use strict';

  var STORE_KEY = 'hk_vehicle';
  var dataPromise = null;

  function loadData(src) {
    if (!dataPromise) {
      dataPromise = fetch(src)
        .then(function (r) { return r.ok ? r.json() : { makes: [] }; })
        .catch(function () { return { makes: [] }; });
    }
    return dataPromise;
  }

  function getSaved() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); }
    catch (e) { return null; }
  }

  function save(vehicle) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(vehicle)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hk:vehicle:change', { detail: vehicle }));
  }

  function clearSaved() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hk:vehicle:change', { detail: null }));
  }

  function fill(select, values, placeholder) {
    select.innerHTML = '';
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder;
    select.appendChild(opt);
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      select.appendChild(o);
    });
    select.disabled = values.length === 0;
  }

  function yearRange(from, to) {
    var out = [];
    var end = to || new Date().getFullYear();
    for (var y = end; y >= from; y--) out.push(String(y));
    return out;
  }

  /* Build the results URL. Search is used because make / model / year are
     present in the product titles today. */
  function buildUrl(vehicle) {
    var terms = [vehicle.make, vehicle.model, vehicle.year].filter(Boolean).join(' ');
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(terms);
  }

  function initFinder(root) {
    var src = root.dataset.vehicleData;
    var makeSel = root.querySelector('[data-hk-make]');
    var modelSel = root.querySelector('[data-hk-model]');
    var yearSel = root.querySelector('[data-hk-year]');
    var form = root.querySelector('[data-hk-finder-form]');
    if (!makeSel || !modelSel || !yearSel || !form) return;

    var db = { makes: [] };

    function modelsFor(makeName) {
      var m = db.makes.filter(function (x) { return x.name === makeName; })[0];
      return m && m.models ? m.models.map(function (mm) { return mm.name || mm; }) : [];
    }

    function yearsFor(makeName, modelName) {
      var m = db.makes.filter(function (x) { return x.name === makeName; })[0];
      if (!m) return yearRange(1998);
      var mm = (m.models || []).filter(function (x) { return (x.name || x) === modelName; })[0];
      if (mm && mm.years && mm.years.length) return mm.years.slice().sort().reverse().map(String);
      return yearRange(mm && mm.from ? mm.from : 1998, mm && mm.to ? mm.to : null);
    }

    /* Every make the catalogue knows about, for the second step. */
    function allMakes() {
      return db.makes.map(function (m) { return m.name; });
    }

    /* Makes that actually list the chosen year, falling back to every make
       when the catalogue has no year data for them yet. */
    function makesForYear(year) {
      if (!year) { return allMakes(); }
      var hit = db.makes.filter(function (m) {
        return (m.models || []).some(function (mm) {
          return yearsFor(m.name, mm.name || mm).indexOf(String(year)) > -1;
        });
      }).map(function (m) { return m.name; });
      return hit.length ? hit : allMakes();
    }

    function modelsForYear(makeName, year) {
      var models = modelsFor(makeName);
      if (!year) { return models; }
      var hit = models.filter(function (mm) {
        return yearsFor(makeName, mm).indexOf(String(year)) > -1;
      });
      return hit.length ? hit : models;
    }

    loadData(src).then(function (json) {
      db = json && json.makes ? json : { makes: [] };
      fill(yearSel, yearRange(1998), 'Select Year');
      fill(makeSel, [], 'Select Make');
      fill(modelSel, [], 'Select Model');

      var saved = getSaved();
      if (saved && saved.year) {
        yearSel.value = saved.year;
        fill(makeSel, makesForYear(saved.year), 'Select Make');
      } else {
        fill(makeSel, allMakes(), 'Select Make');
      }
      if (saved && saved.make) {
        makeSel.value = saved.make;
        if (makeSel.value) {
          fill(modelSel, modelsForYear(saved.make, saved.year), 'Select Model');
          if (saved.model) { modelSel.value = saved.model; }
        }
      }
    });

    yearSel.addEventListener('change', function () {
      fill(makeSel, makesForYear(yearSel.value), 'Select Make');
      fill(modelSel, [], 'Select Model');
    });

    makeSel.addEventListener('change', function () {
      fill(modelSel, modelsForYear(makeSel.value, yearSel.value), 'Select Model');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!yearSel.value) { yearSel.focus(); return; }
      if (!makeSel.value) { makeSel.focus(); return; }
      var vehicle = { make: makeSel.value, model: modelSel.value, year: yearSel.value };
      save(vehicle);
      window.location.href = buildUrl(vehicle);
    });

    var change = root.querySelector('[data-hk-change-vehicle]');
    if (change) {
      change.addEventListener('click', function (e) {
        e.preventDefault();
        clearSaved();
        yearSel.value = '';
        fill(makeSel, [], 'Select Make');
        fill(modelSel, [], 'Select Model');
        yearSel.focus();
      });
    }
  }

  function initPartSearch(root) {
    var form = root.querySelector('[data-hk-part-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) { e.preventDefault(); input && input.focus(); }
    });
  }

  function boot() {
    document.querySelectorAll('[data-hk-finder]').forEach(function (root) {
      initFinder(root);
      initPartSearch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Exposed so other sections (product fitment check, listing badges) can read
     the chosen vehicle without duplicating the storage contract. */
  window.HKVehicle = {
    get: getSaved,
    set: save,
    clear: clearSaved,
    key: STORE_KEY
  };
})();
